<template>
  <div style="text-align: left; margin-left: 20px;">
    <div style="margin-top: 10px;">
        <span type="label">Title</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            v-model="$store.state.inventoryMaster.props.estore_preview_title1"
            style="width: 700px;">
        </el-input>
    </div>
    <div style="margin-top: 10px;">
        <span type="label">Sub-Title</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            v-model="$store.state.inventoryMaster.props.estore_preview_title2"
            style="width: 700px;">
        </el-input>
    </div>

    <div style="margin-top: 10px;">
        <span type="label">Description</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            type="textarea"
            :rows="20"
            v-model="$store.state.inventoryMaster.props.estore_preview_content"
            style="width: 100%;">
        </el-input>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/EStore/AdditionalInformation.vue